import React from "react";
import { useStepperContext } from "./StepperContext";
import { Progress } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StepperHeader = ({ className = "" }) => {
  const { currentStep, steps } = useStepperContext();

  return (
    <div className={`mb-4 ${className}`}>
      <div className="d-flex justify-content-between position-relative">
        {steps.map((step, index) => {
          const StepIcon = step.icon;
          return (
            <div
              key={index}
              className="text-center position-relative"
              style={{ flex: 1 }}
            >
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2 ${
                  index <= currentStep ? "bg-primary" : "bg-secondary"
                }`}
                style={{
                  width: "40px",
                  height: "40px",
                  color: "white",
                  transition: "background-color 0.3s",
                  zIndex: 2,
                  position: "relative",
                }}
              >
                <FontAwesomeIcon icon={StepIcon} />
              </div>
              <span
                className={
                  index <= currentStep ? "text-primary" : "text-secondary"
                }
              >
                {step.title}
              </span>
              {index < steps.length - 1 && (
                <div
                  className="position-absolute"
                  style={{
                    top: "20px",
                    left: "50%",
                    right: "-50%",
                    width: "100%",
                    height: "2px",
                    background: index < currentStep ? "#007bff" : "#dee2e6",
                    zIndex: 1,
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
      <Progress
        value={(currentStep / (steps.length - 1)) * 100}
        className="mb-4"
      />
    </div>
  );
};

export default StepperHeader;
